import { render, staticRenderFns } from "./UserTicket.vue?vue&type=template&id=2d81701d&scoped=true"
import script from "./UserTicket.vue?vue&type=script&lang=ts"
export * from "./UserTicket.vue?vue&type=script&lang=ts"
import style0 from "./UserTicket.vue?vue&type=style&index=0&id=2d81701d&prod&lang=scss"
import style1 from "./UserTicket.vue?vue&type=style&index=1&id=2d81701d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d81701d",
  null
  
)

export default component.exports